import { defineComponent as _defineComponent } from 'vue'
import { computed, useStore, useContext } from '@nuxtjs/composition-api';
import CheckIcon from './CheckIcon.vue';
import { State } from '@/store';
import { useLocale } from '~/composables/useLocale';
import schoolPlan from '~/data/school_plan';
import TLinkButton from '~/components/atoms/t-link-button.vue';
import { UserSubscriptionCode } from '~/types/plan';

export interface PlanCardProps {
  currentPlan: UserSubscriptionCode | null;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SchoolPlanCallout',
  props: {
    currentPlan: null
  },
  setup(__props: any) {

const props = __props as {
  currentPlan: UserSubscriptionCode | null;
};

const { $mzAnalyticsApi } = useContext();
const $store = useStore<State>();
const deviceId = computed(() => $store.getters.deviceId);

const locale = useLocale();
const price = computed(() => schoolPlan[locale.value].price);
const isSchoolMember = computed(() => {
  return (
    props.currentPlan === 'school_plan_member' ||
    props.currentPlan === 'school_plan_admin_only' ||
    props.currentPlan === 'school_ultimate' ||
    props.currentPlan === 'school_plan'
  );
});
const schoolPlanClicked = () => {
  if (!isSchoolMember.value) {
    $mzAnalyticsApi({
      event: 'click',
      name: 'upgrade.school_plan.start_with_5_licences',
      productArea: 'profile',
    });
  }
};

return { __sfc: true,$mzAnalyticsApi, $store, deviceId, props, locale, price, isSchoolMember, schoolPlanClicked, CheckIcon, TLinkButton }
}

})